module.exports = __webpack_public_path__ + "img/statistics.04632237.png";